import { Container, FlexContainer, LineSeparator } from '@news12/storybook-news'

import React from 'react'

import livePageStyle from '../../styles/components/livePage/live_page'
import { structure } from '../../styles/global'
import BaseCSS from '../../styles/global/BaseCSS'
import AdUnit from '../Ads/AdUnit'
import Live from '../ComponentMap/Live'
import Metadata from '../Metadata'
import UnresetCSS from '../UnresetCSS'
import TopStories from './TopStories'

import Head from 'next/head'

const LivePage = ({ topStories, metadata, withAds, livestream, providers }) => (
  <>
    <Head>
      <title>{metadata?.title}</title>
    </Head>
    <Metadata metadata={metadata} />
    <div className='main-layout-container'>
      <div className='main-layout'>
        {withAds && (
          <Container margin={['1.5rem 0 0', '2.5rem auto 0']}>
            <FlexContainer justifyContent='center'>
              <AdUnit adUnitTemplate='leaderboard' id='ad-banner-top' type='leaderboardRedesign' />
            </FlexContainer>
            <LineSeparator margin={['2.25rem auto', '2.5rem auto']} />
          </Container>
        )}
        <Live livestream={livestream} providers={providers} />
        {withAds && (
          <Container margin={['1.5rem 0 0', '2.5rem auto 0']}>
            <LineSeparator margin={['2.25rem auto', '2.5rem auto']} />
            <FlexContainer justifyContent='center'>
              <AdUnit adUnitTemplate='leaderboard' id='ad-banner-middle-0' type='leaderboardDynamic' />
            </FlexContainer>
            <LineSeparator margin={['2.25rem auto', '2.5rem auto']} />
          </Container>
        )}
        <TopStories topStories={topStories} />
      </div>
    </div>
    <style jsx>{livePageStyle}</style>
    <style jsx global>
      {structure}
    </style>
    <UnresetCSS />
    <BaseCSS />
  </>
)

export default LivePage
